export default __webpack_public_path__ + "static/media/hm_tysonfeat.3b9d82ad.jpg";